import GNB from '@/common/resources/GNB'
import _ from 'lodash'
import fp from 'lodash/fp'
import { EVENT_TYPE, MENU, UI_CODE } from '@/common/resources/const'
import { getTimeStamp } from '@/common/utils/common'

const getGnbList = () => _.get(GNB, 'gnblist')
const curriedFilterFn = (uiCode) => (gnb) => gnb.uicode === uiCode
const curriedEventTypeFilter = (eventType) => (event) => event.type === eventType
const getEventObjectByType = (eventType) => fp.flow(fp.filter(curriedEventTypeFilter(eventType)), fp.first)
export const GNBEventMapper = (eventList) => {
  return {
    onClick: getEventObjectByType(EVENT_TYPE.ON_CLICK)(eventList),
    onContent: getEventObjectByType(EVENT_TYPE.ON_CONTENT)(eventList)
  }
}
const SectionEventMapper = (eventList) => {
  return {
    onClick: getEventObjectByType(EVENT_TYPE.ON_CLICK)(eventList),
    onContent: getEventObjectByType(EVENT_TYPE.ON_CONTENT)(eventList),
    onViewMore: getEventObjectByType(EVENT_TYPE.ON_VIEW_MORE)(eventList),
    onNavigation: getEventObjectByType(EVENT_TYPE.ON_NAVIGATION)(eventList),
    onMoveTab: getEventObjectByType(EVENT_TYPE.ON_MOVE_TAB)(eventList)
  }
}
export const CellEventMapper = (eventList) => {
  return {
    onClick: getEventObjectByType(EVENT_TYPE.ON_CLICK)(eventList),
    onNavigation: getEventObjectByType(EVENT_TYPE.ON_NAVIGATION)(eventList),
    onDetail: getEventObjectByType(EVENT_TYPE.ON_DETAIL)(eventList),
    onInstantPlay: getEventObjectByType(EVENT_TYPE.ON_INSTANT_PLAY)(eventList),
    onZzim: getEventObjectByType(EVENT_TYPE.ON_ZZIM)(eventList),
    offZzim: getEventObjectByType(EVENT_TYPE.OFF_ZZIM)(eventList)
  }
}

const getGnbEventListByUiCode = (uiCode) => {
  return fp.flow(
    getGnbList,
    fp.filter(curriedFilterFn(uiCode)),
    fp.first,
    fp.get('eventlist'),
    fp.thru(GNBEventMapper)
  )()
}
export const getSectionEventObject = fp.thru(SectionEventMapper)
export const getCellEventObject = fp.thru(CellEventMapper)
export const getSectionEventByType = (eventType) => fp.flow(
  fp.getOr([], 'eventlist'),
  getSectionEventObject,
  fp.find(event => _.get(event, 'type', '') === eventType)
)

// TODO: 정식 API 나오면 수정 (인스턴트 라이브 페이지가 기존 라이브 페이지를 대체가 )

export const GNB_EVENT_LIST = {
  [MENU.HOME]: getGnbEventListByUiCode(UI_CODE.HOME),
  [MENU.BROADCAST]: getGnbEventListByUiCode(UI_CODE.BROADCAST),
  [MENU.LIVE]: getGnbEventListByUiCode(UI_CODE.LIVE),
  [MENU.MOVIE]: getGnbEventListByUiCode(UI_CODE.MOVIE),
  [MENU.MOVIE_17]: getGnbEventListByUiCode(UI_CODE.MOVIE_17),
  [MENU.MOVIE_18]: getGnbEventListByUiCode(UI_CODE.MOVIE_18),
  [MENU.GLOBAL]: getGnbEventListByUiCode(UI_CODE.GLOBAL),
  [MENU.CLIP]: getGnbEventListByUiCode(UI_CODE.CLIP),
  [MENU.BASEBALL]: getGnbEventListByUiCode(UI_CODE.BASEBALL),
  [MENU.MY]: getGnbEventListByUiCode(UI_CODE.MY)
}
const isParsableBodyList = obj => {
  try {
    const json = JSON.parse(obj)
    return typeof json === 'object'
  } catch (e) {
    return false
  }
}

export const eventBodyListParser = (event) => {
  const bodyList = _.get(event, 'bodylist', [])
  if (isParsableBodyList(bodyList[0])) { // 검색에서만 쓰이는 이상한 규격
    return JSON.parse(bodyList[0])
  } else {
    return fp.flow(
      fp.getOr([], 'bodylist'),
      fp.map(fp.split(':')),
      fp.fromPairs,
      fp.thru(val => _.set(val, 'timestamp', getTimeStamp()))
    )(event)
  }
}

export const getBand = fp.flow(
  fp.getOr([], ['data', 'band'])
)
export const getCellList = fp.flow(
  getBand,
  fp.getOr([], 'celllist')
)
export const getButtonInfo = fp.flow(
  getBand,
  fp.getOr(null, 'buttoninfo')
)
export const getGameCount = fp.flow(
  getBand,
  fp.getOr(0, 'game_count')
)
const FORCE_UPDATE_MULTI_SECTION_LIST = [MENU.HOME, MENU.LIVE, MENU.BASEBALL, MENU.MY]
export function isForceUpdate (gnbCode) {
  return FORCE_UPDATE_MULTI_SECTION_LIST.indexOf(gnbCode) > -1
}
